import { rgba } from "polished";
import styled from "styled-components";
import { TitleStyled } from "../../../../../base/text/title/views/desktop/styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../styles/common/mixins/logical.styled.js";
export const BlogFeed = styled.div.withConfig({
    displayName: "styled__BlogFeed",
    componentId: "sc-14709a1b-0"
})`
	${FlexMixin({
    direction: 'column',
    justify: 'center'
})}
	margin: 0 auto;
	max-width: 1500px;
	position: relative;
	width: 100%;

	${TitleStyled} {
		${FlexMixin({
    justify: 'center'
})};
	}
`;
export const BlogList = styled.div.withConfig({
    displayName: "styled__BlogList",
    componentId: "sc-14709a1b-1"
})`
	${FlexMixin({
    direction: 'column'
})}
	gap: 24px;

	${({ theme  })=>theme.media.up('lg')} {
		flex-wrap: wrap;
		${({ $single  })=>$single === 1 ? `
				height: auto;
			;` : `height: 440px;`}
	}
`;
export const BlogListSecondary = styled.div.withConfig({
    displayName: "styled__BlogListSecondary",
    componentId: "sc-14709a1b-2"
})`
	${FlexMixin({
    direction: 'row'
})}
	gap: 24px;
	height: 100%;
	width: 100%;

	${({ theme  })=>theme.media.up('lg')} {
		width: calc(50% - 12px);
		${FlexMixin({
    direction: 'column'
})}
	}
`;
export const BlogFeedFooter = styled.footer.withConfig({
    displayName: "styled__BlogFeedFooter",
    componentId: "sc-14709a1b-3"
})`
	display: block;
	text-align: center;
`;
export const BlogFeedFooterDescription = styled.p.withConfig({
    displayName: "styled__BlogFeedFooterDescription",
    componentId: "sc-14709a1b-4"
})`
	${FontMixin({
    size: 'base',
    height: 'large',
    weight: 'light'
})}
	color: ${({ theme  })=>theme.colors.grays.dark};
	margin: 24px 0 20px;
`;
export const BlogFeedFooterLink = styled.a.withConfig({
    displayName: "styled__BlogFeedFooterLink",
    componentId: "sc-14709a1b-5"
})`
	${BorderRadius({
    all: '4px'
})}
	${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'medium'
})}
	background-color: ${({ theme  })=>theme.colors.primary.light};
	border: 0;
	color: ${({ theme  })=>theme.colors.white.base};
	display: inline-block;
	padding: 12px 16px;
	text-transform: uppercase;

	&:hover {
		background-color: ${({ theme  })=>rgba(theme.colors.primary.light ?? theme.colors.primary.base, 0.97)};
	}
`;

//# sourceMappingURL=styled.js.map